import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdvertData } from '../../redux/advertSlice';
import { Preloader } from '../../components/Preloader';
import { Navigate, Route, Routes } from 'react-router-dom';
import { EmptyPage } from '../EmptyPage';
import { AdvertMap } from './AdvertMap';
import { Promoters } from './Promoters';
import { AdvertHeader } from './AdvertHeader';
import { accessor } from '../../helpers';
import { RoutesPage } from './Routes';
import { SpreadFlyers } from './SpreadFlyers';
import { GivenFlyers } from './GivenFlyers';
import { FinishedRoutes } from './FinishedRoutes';
import { FinishedRoutePage } from './FinishedRoute';
import { Interviews } from './Interviews';

export const AdvertPage = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.auth);
    const advertAccess = accessor.advertAccess(userInfo);
    const promotersInteractAccess = accessor.promoterInteractAccess(userInfo);
    const advertCities = useSelector((state) => state.settings.advertCities);
    const cityList = advertCities.length ? advertCities : [{_id: 'null', name: 'Нет доступных городов', UTC: 0}]
    const flyerTypes = useSelector((state) => state.settings.flyerTypes);
    const flyerList = flyerTypes.length ? flyerTypes : [{_id: 'null', name: 'Нет доступных листовок', isOwn: false}]

    const months = useSelector((state) => state.advert.months);
    const activeMonth = months.find(m => m.active);

    useEffect(() => {
        advertAccess && dispatch(getAdvertData({month: activeMonth.month}));
    }, []);

    const routes = useSelector((state) => state.advert.routes);
    const promoters = useSelector((state) => state.advert.promoters);
    const finishedRoutes = useSelector((state) => state.advert.finishedRoutes);
    const isLoaded = useSelector((state) => state.advert.isLoaded);
    const error = useSelector((state) => state.advert.error);

    if (!advertAccess) {
        return <EmptyPage message={'Нет доступа к рекламе'} />;
    }
    if (!isLoaded) {
        return <Preloader />;
    }
    if (error) {
        return <EmptyPage message={error} />;
    }

    return (
        <div className="page advert-page">
            <AdvertHeader promotersAccess={promotersInteractAccess} />
            <Routes>
                <Route path="/" element={<Navigate to="/advert/active_routes" />} />
                <Route path="proms/*" element={<Promoters cities={cityList} list={promoters} access={promotersInteractAccess} />} />
                <Route path="map" element={<AdvertMap cities={cityList} routes={routes} flyers={flyerList} />} />
                <Route path="active_routes/*" element={<RoutesPage cities={cityList} list={routes} promoters={promoters} />} />
                <Route path="spread_flyers" element={<SpreadFlyers cities={cityList} promoters={promoters} months={months} flyerTypes={flyerTypes} routes={routes} />} />
                <Route path="given_flyers" element={<GivenFlyers cities={cityList} promoters={promoters} months={months} />} />
                <Route path="payment_routes" element={<FinishedRoutes cities={cityList} promoters={promoters} months={months} />} />
                <Route path="interviews" element={<Interviews cities={cityList} />} />
                <Route path="finished_route/*" element={<FinishedRoutePage routes={finishedRoutes}/>} />
                <Route path="*" element={<EmptyPage message="Страница не найдена" />} />
            </Routes>
        </div>
    );
};
